/*
 * @providesModule Device
 */

import Sizes from 'Sizes';

export default {
  isTabletUI(): boolean {
    return Sizes.isTablet();
  }
};
